export default __webpack_public_path__ + "static/Tek_Light-abe4b7b5f90f053e53c2db4e2f84832a.png";